const reducerName = '@cityoo-backoffice/tenants';

export const RESET = `${reducerName}/RESET`;

export const SET_CURRENT_PAGE = `${reducerName}/SET_CURRENT_PAGE`;

export const GET_TENANTS_START = `${reducerName}/GET_TENANTS_START`;
export const GET_TENANTS_SUCCESS = `${reducerName}/GET_TENANTS_SUCCESS`;
export const GET_TENANTS_FAIL = `${reducerName}/GET_TENANTS_FAIL`;
